import React, {Component} from 'react';
import {Icon} from 'semantic-ui-react';

export class Toggle extends Component {

    constructor(props){
        super(props);
        this.state = {
            active:this.props.forceActive,
        }
    }
    componentWillUpdate(nextProps, nextState, nextContext) {
        if(this.props.forceActive !== nextProps.forceActive){
            this.setState({active:nextProps.forceActive})
        }
    }

    render() {
        return (
            <div className="toggable" style={{background: this.state.active? "#0f76fd05" : '#fff'}}>
                <div style={{zIndex:500,position:this.props.topAmt?"sticky":undefined,top:this.props.topAmt}}className={`toggable_heading 
                    ${this.props.topAmt && this.props.room ? "toggable_heading_room" :""} 
                    ${this.props.topAmt && this.props.group ? "toggable_heading_group":""}`}>
                    <span onClick={() => {this.setState({active:!this.state.active})}} style={{minWidth: '2%'}}> {this.state.active?
                        <Icon name="caret down" size='large'/> : <Icon name="caret right" size='large'/>}</span>
                    {this.props.title}
                </div>
                {
                    this.state.active?   (
                        <div className="toggable_content ">
                            {this.props.children}
                        </div>
                    ) : null
                }
            </div>
        )
    }
}

export class CollapsiblePanel extends Component {

    render() {
        const children = React.Children.map(this.props.children, (child, i) => {
            return React.cloneElement(child, {
                propActive:false
            })
        });
        return (
            <div className="accordion">
                {children}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/universal/collapsiblePanel.js